import React from "react";
import { MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from "lucide-react";
import { GlitterSparkles } from "./GlitterSparkles";
type ContactPageProps = {
  onBack: () => void;
};
const phoneNumber = "+12088813989";
const phoneDisplay = "(208) 881-3989";
const email = "pickenspassion@gmail.com";
const desktopBackground = "https://cdn.magicpatterns.com/uploads/i22mEGTb9wuQHDTSXBQdQq/ChatGPT_Image_Oct_5,_2026,_09_27_46_PM.png";
const mobileBackground = "https://cdn.magicpatterns.com/uploads/9zkL4mQ8yMPprXfwKXCcaD/ChatGPT_Image_Oct_5,_2026,_09_29_01_PM.png";
const pillButtonClass = "inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]";
export function ContactPage({
  onBack
}: ContactPageProps) {
  return <main className="relative min-h-[100dvh] w-full bg-[#10070f] px-4 py-10 text-white sm:px-8 sm:py-14" data-id="element-177" data-mp="1q6qhtjmqc4gl">
      {/* Jeweled background pinned to the screen */}
      <div className="pointer-events-none fixed inset-0 bg-cover bg-center md:hidden" style={{
      backgroundImage: `url(${mobileBackground})`
    }} aria-hidden="true" data-id="element-178" data-mp="ncqa8iidi56m" />
      <div className="pointer-events-none fixed inset-0 hidden bg-cover bg-center md:block" style={{
      backgroundImage: `url(${desktopBackground})`
    }} aria-hidden="true" data-id="element-179" data-mp="11bpznsdpmo3u" />
      {/* Animated glitter over the background */}
      <div className="pointer-events-none fixed inset-0" aria-hidden="true" data-id="element-180" data-mp="9iyz55ozud8s">
        <GlitterSparkles count={500} data-id="element-181" data-mp="4o3745jrbpvo" />
      </div>
      <div className="relative mx-auto max-w-xl" data-id="element-182" data-mp="ie6oai3s4te9">
        <button type="button" onClick={onBack} className="mb-6 rounded-full bg-[#10070f]/80 px-3 py-1.5 text-sm font-medium text-[#35dceb] underline decoration-transparent underline-offset-4 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#35dceb]" data-id="element-183" data-mp="iey9cyzr38qa">
          Back to home
        </button>

        <div className="rounded-2xl border border-[#ff3aa2]/35 bg-[#10070f]/85 p-5 backdrop-blur-sm sm:p-8" data-id="element-184" data-mp="1pz3kh04dh6rz">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#35dceb]" data-id="element-185" data-mp="1uq2346cu2gye">Pickens Passion</p>

        <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-186" data-mp="1zpok8qvs8hch">
          <a href={`sms:${phoneNumber}`} className={`${pillButtonClass} bg-[#ff3aa2] text-white hover:bg-[#ff5bad]`} data-id="element-187" data-mp="1zr9ai4b2de4j">
            <MessageCircleIcon size={18} aria-hidden="true" data-id="element-188" data-mp="170hi7hx4d9mh" />
            Text us
          </a>
          <a href={`tel:${phoneNumber}`} className={`${pillButtonClass} bg-[#35dceb] text-[#10070f] hover:bg-white`} data-id="element-189" data-mp="1c03w7tkrutwc">
            <PhoneIcon size={18} aria-hidden="true" data-id="element-190" data-mp="1gz73lko85c7h" />
            Call us
          </a>
        </div>

        <div className="mt-8 space-y-4 border-t border-[#ff3aa2]/40 pt-6" data-id="element-191" data-mp="2nfskco9rhyyq">
          <a href={`mailto:${email}`} className="block text-sm font-semibold uppercase tracking-wide text-[#35dceb] underline decoration-transparent underline-offset-4 hover:decoration-current" data-id="element-192" data-mp="2sdu295vgbs8m">
            {email}
          </a>

          <p className="flex items-center gap-2 text-sm text-white/80" data-id="element-193" data-mp="bsp1pchav46x">
            <MapPinIcon size={16} className="text-[#ff5bad]" aria-hidden="true" data-id="element-194" data-mp="70nva76tc7ot" />
            Idaho Falls, ID 83404
          </p>

          <p className="flex items-center gap-2 text-sm text-white/80" data-id="element-195" data-mp="20t4s4qy9k4a">
            <PhoneIcon size={16} className="text-[#ff5bad]" aria-hidden="true" data-id="element-196" data-mp="3t8ndx47gppmb" />
            <span data-id="element-197" data-mp="3p6jzq7tes6xc">
              <a href={`tel:${phoneNumber}`} className="font-medium text-[#35dceb] hover:underline" data-id="element-198" data-mp="3p60v1ssrrf19">
                {phoneDisplay}
              </a>
              <span className="text-white/60" data-id="element-199" data-mp="3k7pihab3aqfc"> — call or text</span>
            </span>
          </p>
        </div>

        <a href={`mailto:${email}`} className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/80 px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-white hover:text-[#10070f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" data-id="element-200" data-mp="3fagwszqqg49c">
          <MailIcon size={16} aria-hidden="true" data-id="element-201" data-mp="f32mofl0widn" />
          Drop us a line!
        </a>
        </div>
      </div>
    </main>;
}